import { useMutation } from 'react-query'

import { request } from '../utils/api'
import { HTTPMethod } from '../utils/api.types'
import type { Response } from '../utils/api.types'

type RequestGuestRequest = {
  live_id: string
  token: string
  name?: string
  question: string
}

type RequestGuestResponse = Response & {
  data: {
    live_speaker_id: string
    room_link: string
    presenter_token: string
  }
}

type RequestGuestData = {
  sessionId: string
  token: string
  name?: string
  question: string
}

type RequestGuestMutationRequest = {
  sessionId: string
  token: string
  name?: string
  question: string
}

type RequestGuestMutationResponse = {
  liveSpeakerId: string
  roomLink: string
  presenterToken: string
}

function requestGuest(data: RequestGuestData) {
  return request<RequestGuestRequest, RequestGuestResponse>({
    url: '/api/2/live/speaker/request-guest',
    method: HTTPMethod.POST,
    data: {
      live_id: data.sessionId,
      token: data.token,
      name: data.name ?? 'Unknown',
      question: data.question,
    },
  })
}

function useRequestGuestMutation() {
  return useMutation<
    RequestGuestMutationResponse,
    unknown,
    RequestGuestMutationRequest
  >(async (data) => {
    const response = await requestGuest(data)

    const mutationResponse: RequestGuestMutationResponse = {
      liveSpeakerId: response.data.live_speaker_id,
      presenterToken: response.data.presenter_token,
      roomLink: response.data.room_link,
    }

    return mutationResponse
  })
}

export { useRequestGuestMutation }
